import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
  common: {
    version: '0.0.0-one-fe-webapp'
  }
}

export {
  state,
  mutations,
  actions,
  getters
}
